import { useEffect } from 'react';
import { getFeaturesDto, getVisualContentRaw } from '../services/restaurantDataService';
import { useItemsStore } from '../store';
import { normalizeVisualContent } from '../utils/normalizeVisualContent';

export const useVisualContent = (
  restaurantId: string | undefined,
  assetsVersionIso: string | null
): void => {
  const setFeaturesStore = useItemsStore((s) => s.setFeatures);
  const setCarouselContentStore = useItemsStore((s) => s.setCarouselContent);

  useEffect(() => {
    if (!restaurantId || !assetsVersionIso) return;
    const controller = new AbortController();

    Promise.all([
      getFeaturesDto(restaurantId, assetsVersionIso, controller.signal),
      getVisualContentRaw(restaurantId, assetsVersionIso, controller.signal),
    ])
      .then(([features, visualRaw]) => {
        if (controller.signal.aborted) return;
        setFeaturesStore(Array.isArray(features) ? features : []);
        setCarouselContentStore(normalizeVisualContent(visualRaw, restaurantId));
      })
      .catch(() => {
        if (controller.signal.aborted) return;
        setFeaturesStore([]);
        setCarouselContentStore([]);
      });

    return () => controller.abort();
  }, [restaurantId, assetsVersionIso, setFeaturesStore, setCarouselContentStore]);
};
